
import { defineComponent } from "vue";
import Header from "@/components/Header.vue";
import Content from "@/components/Content.vue";
import Footer from "@/components/Footer.vue";
import BackToTop from "@/components/BackToTop.vue";
import "@/assets/global.scss";
import "element-plus/lib/theme-chalk/display.css";

export default defineComponent({
  name: "App",
  components: {
    Header,
    Content,
    Footer,
    BackToTop
  },
  setup() {
    return {};
  }
});
